<div class="flex">
  <IToasterList />
  <div class="flex h-screen flex-1 flex-col overflow-auto">
    @if (isTest || isAdminLogin()) {
      <div
        class="flex w-full items-center justify-between px-4 py-1.5 text-white"
        [ngClass]="isTest ? 'bg-orange-600' : 'bg-red-600'"
      >
        <div>
          @if (isTest) {
            <span class="font-semibold">Demo environment</span>
          } @else {
            <span class="font-bold">Production environment</span>
          }
          @if (isAdminLogin()) {
            <span> • Logged from Board Admin</span>
          }
        </div>
        <button iButton variant="secondary" size="sm" (click)="printDebugInfo()">
          {{ "Debug Info" }}
        </button>
      </div>
    }
    @if (globalWarning$ | async) {
      <div class="border-sha w-full rounded-xs bg-red-100 px-4 py-1 text-red-700">
        {{ globalWarning$ | async }}
      </div>
    }
    <header class="sticky top-0 z-[50] flex w-full flex-col bg-white py-2">
      <div class="flex min-w-0 flex-1 items-center justify-between px-6" *transloco="let t">
        <div class="flex h-[2.5rem] items-center gap-4">
          <a class="block h-full" routerLink="/dashboard360" queryParamsHandling="merge">
            <app-logo></app-logo>
          </a>
          <ITabs [tabs]="tabs" [activeTab]="activeTab()" />
        </div>

        <button iButton [iDropdownMenuTrigger]="settingsMenu" placement="bottom-end" variant="ghost">
          <IIcon name="gear" />
        </button>

        <ng-template #settingsMenu>
          <IDropdownMenu>
            <button iDropdownMenuItem (click)="router.navigate(['/dashboard360/profile'])">
              <IIcon name="user" />
              {{ t("dashboard360-layout.my_profile") }}
            </button>
            <button iDropdownMenuItem (click)="logout()">
              <IIcon name="logout" />
              {{ t("dashboard360-layout.logout") }}
            </button>
          </IDropdownMenu>
        </ng-template>
      </div>
    </header>
    <div class="flex-1 p-4">
      <app-page-layout>
        <router-outlet />
      </app-page-layout>
    </div>
  </div>
</div>
